import { ApiResponse } from "../types/ApiResponse";
import { TinyObj } from "../types/TinyObj";
import { TinyUser, User } from "../types/user";
import { GetTinyUsersDto } from "../types/user/GetTinyUsersDto";
import { UpsertUser } from "../types/user/UpsertUser";
import { UserAuthProfile } from "../types/user/UserAuthProfile";
import { UserRegister } from "../types/user/UserRegister";
import { axiosWithAuth } from "../utils/customAxios";

const usersService = {
  fetchUsers: async (name?: string): Promise<User[]> => {
    try {
      const route = name ? `/user/compressed${name && `?name=${name}`}` : `/user/compressed`;
      const response = await axiosWithAuth.get(route);
      const users: User[] = response.data;

      return users;
    } catch (err) {
      throw err;
    }
  },

  fetchAllUsersPaginated: async (skip: number = 0, take: number = 20, searchTerm: string = "", sortField: string = "email", sortDirection: string = "asc"): Promise<ApiResponse<User>> => {
    try {
      const route = `/user/all?skip=${skip}&take=${take}&searchTerm=${searchTerm}&sortField=${sortField}&sortDirection=${sortDirection}`;
      const response = await axiosWithAuth.get(route);
      const callDetails: ApiResponse<User> = response.data;
      return callDetails;
    } catch (err) {
      throw err;
    }
  },

  updateUser: async (user: UpsertUser, id: number): Promise<User> => {
    try {
      const route = `/user/${id}/profile`;
      const response = await axiosWithAuth.put(route, user);
      const updatedUser: User = response.data;
      return updatedUser;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  deleteUser: async (id: number) => {
    try {
      const route = `/user/${id}`;
      const response = await axiosWithAuth.delete(route);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  updateUserLogin: async (id: number, loginEnabled: boolean) => {
    try {
      const route = `/user/${id}/updatelogin/${loginEnabled ? "true" : "false"
        }`;
      const response = await axiosWithAuth.put(route);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },

  updateUserAuthProfile: async (
    userAuthProfiles: UserAuthProfile[]
  ): Promise<User[]> => {
    try {
      const route = `/user/authorizationprofile`;
      const response = await axiosWithAuth.put(route, userAuthProfiles);
      const updatedUsers: User[] = response.data;
      return updatedUsers;
    } catch (err) {
      throw err;
    }
  },
  updateRecordingNetworkAccesibility: async (
    recordingNetworkName: string,
    userId: number
  ): Promise<User> => {
    try {
      const route = `/user/${userId}/recordingNetworkAccess/${encodeURIComponent(recordingNetworkName)}`;
      const response = await axiosWithAuth.put(route);
      const updatedUser: User = response.data;
      return updatedUser;
    } catch (err) {
      throw err;
    }
  },
  updateRecordingNetworkViaGroup: async (
    userGroups: number[],
    userId: number
  ): Promise<User> => {
    try {
      const route = `/user/${userId}/recordingnetwork`;
      const response = await axiosWithAuth.put(route, userGroups);
      const updatedUser: User = response.data;
      return updatedUser;
    } catch (err) {
      throw err;
    }
  },

  getUser: async (userId: string): Promise<User> => {
    try {
      const route = `user/${userId}?features=maximum`;
      var response = await axiosWithAuth.get(route);
      const user = response.data;
      return user;
    } catch (err) {
      throw err;
    }
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await axiosWithAuth.get("user/me?features=maximum");
    const currentUser: User = response.data;

    return currentUser;
  },

  getCurrentTinyUser: async (): Promise<TinyUser> => {
    const response = await axiosWithAuth.get("user/me?features=minimum");
    const currentUser: TinyUser = response.data;

    return currentUser;
  },

  getTinyUsers: async (data: GetTinyUsersDto): Promise<TinyUser[]> => {
    const response = await axiosWithAuth.post("user/tiny", data);
    const tinyUsers: TinyUser[] = response.data;

    return tinyUsers;
  },

  insertUser: async (newUser: UpsertUser): Promise<User> => {
    try {
      const route = `/user`;
      var response = await axiosWithAuth.post(route, newUser);
      const user = response.data;

      return user;
    } catch (err) {
      throw err;
    }
  },

  getAllTinyUsers: async (): Promise<TinyUser[]> => {
    const response = await axiosWithAuth.get(`/user?features=minimum`);
    const users: TinyUser[] = response.data;

    return users;
  },
};

export default usersService;
